import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "../../config/api";
export default function DesignerDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [designer, setDesigner] = useState(null);
  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loadUser = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      setUser(loginUser);

      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
        setWishlist(saved);
      } else {
        setWishlist([]);
      }
    };

    loadUser();

    window.addEventListener("userLogin", loadUser);
    window.addEventListener("userLogout", loadUser);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", loadUser);
    };
  }, []);

  useEffect(() => {
    const updateWishlist = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
        setWishlist(saved);
      }
    };

    // 🔥 Listen for the universal update event
    window.addEventListener("cartUpdated", updateWishlist);
    // Listen for changes made in other browser tabs
    window.addEventListener("storage", updateWishlist);

    return () => {
      window.removeEventListener("cartUpdated", updateWishlist);
      window.removeEventListener("storage", updateWishlist);
    };
  }, [user]);

  useEffect(() => {
    fetch(`${API.GET_SINGLE_DESIGNER}&id=${id}`)
      .then((res) => res.json())
      .then((data) => setDesigner(data));
  }, [id]);

  const toggleWishlist = () => {
    if (!user || !designer) {
      alert("Please login first");
      return;
    }

    let updated = [...wishlist];
    const index = updated.findIndex(
      (w) =>
        w.id.toString() === designer.id.toString() && w.type === "designer",
    );

    if (index !== -1) {
      updated.splice(index, 1);
    } else {
      updated.push({ ...designer, type: "designer" });
    }

    setWishlist(updated);
    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(updated));

    // 🔥 CHANGE THIS: Use the universal event name
    window.dispatchEvent(new Event("cartUpdated"));
  };

  useEffect(() => {
    const updateWishlist = () => {
      if (user) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];

        setWishlist(saved);
      }
    };

    window.addEventListener("wishlistUpdate", updateWishlist);

    return () => {
      window.removeEventListener("wishlistUpdate", updateWishlist);
    };
  }, [user]);

  if (!designer) return <h3 className="text-center mt-5">Loading...</h3>;

  return (
    <div className="container-fluid product-page">
      <div className="mb-3">
        <button onClick={() => navigate(-1)} className="btn btn-light back-btn">
          <i className="bi bi-arrow-left"></i> Back
        </button>
      </div>

      <div className="row">
        {/* Profile Card */}
        <div className="col-lg-4">
          <div className="room-card text-center position-relative">
            <button className="like-btn" onClick={toggleWishlist}>
              <i
                className={
                  wishlist.some(
                    (w) =>
                      w.id.toString() === designer.id.toString() &&
                      w.type === "designer",
                  )
                    ? "bi bi-heart-fill text-danger"
                    : "bi bi-heart"
                }
              ></i>
            </button>
            <img
              src={`${UPLOADS.DESIGNER_IMAGE}${designer.profile}`}
              className="designer-img"
              alt={designer.name}
            />
            <h4 className="mt-3">{designer.name}</h4>
            <p className="text-muted">{designer.skills}</p>
          </div>
        </div>

        {/* Details & Tabs */}
        <div className="col-lg-6">
          <div className="room-card">
            <h3>{designer.name}</h3>
            <h4 className="room-price">₹{designer.expected_salary} / Hr</h4>
            <p className="room-desc">{designer.description}</p>
            <a
              href={`https://wa.me/${designer.phone}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-success mt-3"
            >
              <i className="bi bi-whatsapp me-2"></i> Hire via WhatsApp
            </a>
          </div>

          <div className="mt-3">
            <ul className="nav nav-tabs custom-tabs">
              <li className="nav-item">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                >
                  Profile Info
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#contact"
                >
                  Contact Info
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div className="tab-pane fade show active tab-box" id="profile">
                <table className="info-table">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>{designer.name}</td>
                    </tr>
                    <tr>
                      <th>Skill</th>
                      <td>{designer.skills}</td>
                    </tr>
                    <tr>
                      <th>Experience</th>
                      <td>{designer.experience}</td>
                    </tr>
                    <tr>
                      <th>Location</th>
                      <td>{designer.location}</td>
                    </tr>
                    <tr>
                      <th>Expected Salary</th>
                      <td>₹{designer.expected_salary} / hr</td>
                    </tr>
                    <tr>
                      <th>About Work</th>
                      <td>{designer.description}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="tab-pane fade tab-box" id="contact">
                <table className="info-table">
                  <tbody>
                    <tr>
                      <th>Mobile No</th>
                      <td>{designer.phone}</td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{designer.email}</td>
                    </tr>
                    <tr>
                      <th>Location</th>
                      <td>{designer.location}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>

              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
